import {PropsOf} from "@emotion/react"
import {Button} from "@mui/material"
import {styled} from "@mui/material/styles"
import {FALLBACK_FONT_FAMILY} from "@next/ux-fabric"
import React from "react"

const StyledClearButton = styled(Button)`
    && {
        color: ${({theme}) => theme.uxfabric.components.link.primary.enabled.textColor};
        background: none;
        font-family: ${({theme}) => `${theme.uxfabric.global.body3.fontFamily}, ${FALLBACK_FONT_FAMILY}`} !important;
        font-size: 0.875rem;
        font-weight: ${({theme}) => theme.uxfabric.global.body3.fontWeight};
        text-decoration: underline;
        line-height: 1.43;
        padding: 0;
        justify-content: flex-end;
        border: 0;
        text-transform: none;

        &:hover,
        &:active {
            background: inherit;
            border: 0;
        }

        &:focus {
            border: 0;
            border-radius: 0;
        }
    }
`

export const ClearButton = (props: PropsOf<typeof StyledClearButton>) => {
    return <StyledClearButton disableRipple {...props} />
}
